import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef21da7e&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef21da7e')) {
      api.createRecord('ef21da7e', component.options)
    } else {
      api.reload('ef21da7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef21da7e&lang=pug", function () {
      api.rerender('ef21da7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/parents/profile/index.vue"
export default component.exports